import Link from "next/link";
import { ServiceCard } from "@aqar-app/aqar-design-system";
import { useQuery } from "@apollo/client";
import CardContainer from "../../components/cardContainer/cardContainer";
import {
  dehydrateApolloClient,
  initApolloClient,
} from "../../lib/apolloClient";
import { GET_ALL_CITIES } from "../../graphql/queries/regions";
import { getRandomItem } from "../../lib/helpers";
import styles from "./districtReview.module.scss";
import { InitialResolver } from "../../lib/use.middlewares";

const possibleIcons = ["vila-stats", "land-stats", "apartment-stats"];

function DistrictReviewsCities() {
  const { data } = useQuery(GET_ALL_CITIES, {
    variables: {
      category: 0,
    },
  });

  const cities = data?.Web?.cities || [];

  // TODO: handle CSR loading by adding skeletons here

  return (
    <CardContainer
      title="تقييم احياء السعودية"
      cardClassName={styles.districtReviewCard}
      cardContainerClassName={styles.districtReviewContainer}
    >
      <h2 className={styles.subTitle}>الرجاء اختيار المدينة</h2>
      <div className={styles.serviceCardsWrapper}>
        {cities?.map((city) => {
          return (
            <Link
              className={styles.link}
              href={{
                pathname: `/district-reviews/${city.uri}`,
              }}
              key={city.name}
              passHref
              shallow
              hardShallow
            >
              <ServiceCard
                label={city.name}
                iconProps={{
                  type: getRandomItem(possibleIcons),
                }}
                labelClassName={styles.cityName}
                iconClassName={styles.cityIcon}
              />
            </Link>
          );
        })}
      </div>
    </CardContainer>
  );
}

DistrictReviewsCities.getInitialProps = InitialResolver(async (ctx, $res) => {
  const apolloClient = initApolloClient();
  await apolloClient.query({
    query: GET_ALL_CITIES,
    variables: {
      category: 0,
    },
  });
  return $res(dehydrateApolloClient(apolloClient, {}));
});
export default DistrictReviewsCities;
